import { render } from "./unreadNotificationsCount.vue?vue&type=template&id=312b72a0"
import script from "./unreadNotificationsCount.vue?vue&type=script&lang=js"
export * from "./unreadNotificationsCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__